import { msg } from "components/schema/msg";
import { validationPatterns } from "constant/validationPatterns";
import * as Yup from "yup";

export const ResetPasswordSchema = Yup.object().shape({
  password: Yup.string()
    .matches(
      validationPatterns.password,
      msg("passwordPattern")
    )
    .min(6, msg("passwordMin"))
    .required(msg("passwordRequired")),
  confirm_password: Yup.string()
    .oneOf([Yup.ref("password")], msg("passwordsMatch"))
    .required(msg("passwordConfirmRequired")),
});
